<!-- TrustBox widget - Slider -->
<div class="trustpilot-widget" data-locale="de-DE" data-template-id="54ad5defc6454f065c28af8b" data-businessunit-id="6176575fa2f7e91d56648106" data-style-height="240px" data-style-width="100%" data-theme="dark" data-stars="1,2,3,4,5" data-review-languages="de">
  <a href="https://de.trustpilot.com/review/advofin.at" target="_blank" rel="noopener">Trustpilot</a>
</div>
<!-- End TrustBox widget -->
